import React, { Component } from 'react';
import { connect } from 'react-redux';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { BQ_CLICKED_REVIEWS_RATINGS, BQ_NOTABLE_CLIENT_GIG_ELIGIBLE } from '../../utils/bigQueryEvents';
import { validateOverview } from '../../utils/mainComponentsValidator';
import { REVIEWS } from '../../utils/pageSections';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { shouldRenderNotableClients } from '../shared/NotableClients/helper';
import SafePureComponent from '../shared/SafePureComponent';
import CategoriesTreeBreadcrumbs from './CategoriesTreeBreadcrumbs';
import LoyaltySellerBanner from './LoyaltySellerBanner';
import NotableClientsBar from './NotableClientsBar';
import SellerProfile from './SellerProfile';

import './style.scss';

class GigOverview extends Component {

    constructor(props) {
        super(props);

        this.onReviewsClick = this.onReviewsClick.bind(this);
    }

    componentDidMount() {
        const { notableClients } = this.props;
        const { biEvents } = this.context;

        if (notableClients.length) {
            biEvents.sendBigQueryEvent({
                eventName: BQ_NOTABLE_CLIENT_GIG_ELIGIBLE,
                params: {
                    clients: notableClients.map((client) => client.name)
                }
            });
        }
    }

    onReviewsClick() {
        const { biEvents } = this.context;

        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REVIEWS_RATINGS });
        this.props.scrollToSection({ sectionKey: REVIEWS });
    }

    showLoyaltySellerBanner() {
        const { repeatScore } = this.props;
        const { isMobile } = getContext();

        return !isEmpty(repeatScore) && !isMobile;
    }

    render() {
        const {
            overview,
            useStickyLayout,
            studioInfo,
            gigTitle,
            shouldRenderSellerLanguage,
            notableClients
        } = this.props;

        if (!validateOverview({ overview })) {
            return null;
        }

        const { categories, seller } = overview;
        const showLoyaltySellerBanner = this.showLoyaltySellerBanner();
        const showNotableClients = shouldRenderNotableClients(notableClients);
        const showLoyaltyAndClientBar = showLoyaltySellerBanner || showNotableClients;

        const gigOverviewClasses = classNames(
            'gig-overview',
            { 'with-seller-language': shouldRenderSellerLanguage },
            { 'with-loyalty': showLoyaltySellerBanner }
        );
        const loyaltyAndClientBarClasses = classNames(
            'loyalty-and-notable-clients m-t-16 p-t-20 m-b-16',
            { 'notable-clients-rendered': showNotableClients }
        );

        return (
            <div className={gigOverviewClasses}>
                <CategoriesTreeBreadcrumbs categories={categories}/>
                <h1 className="text-display-3">{gigTitle}</h1>
                <div className="seller-overview">
                    <SellerProfile overview={overview}
                        studioInfo={studioInfo}
                        shouldRenderSellerLanguage={shouldRenderSellerLanguage}
                        useStickyLayout={useStickyLayout}/>
                </div>
                { showLoyaltyAndClientBar && (
                    <div className={loyaltyAndClientBarClasses}>
                        { showLoyaltySellerBanner &&
                            <LoyaltySellerBanner sellerName={seller.username}
                                wrap={showNotableClients}
                                displayAltTitle={showNotableClients}/>
                        }
                        { showNotableClients &&
                            <NotableClientsBar notableClients={notableClients}
                                sellerName={seller.username}
                                profilePhoto={overview.seller?.profilePhoto}
                                wrap={showLoyaltySellerBanner}/>
                        }
                    </div>
                )}
            </div>
        );
    }
}

GigOverview.propTypes = {
    overview: shape({
        gig: shape({
            title: string.isRequired,
            rating: number,
            ratingsCount: number,
            ordersInQueue: number
        }),
        categories: shape({
            category: shape({
                name: string,
                slug: string
            }),
            subCategory: shape({
                name: string,
                slug: string
            }),
            nestedSubCategory: shape({
                name: string,
                slug: string
            })
        }),
        seller: shape({
            id: number.isRequired,
            username: string,
            achievement: number,
            isPro: bool,
            hasProfilePhoto: bool,
            profilePhoto: string
        })
    }),
    studioInfo: object,
    scrollToSection: func,
    useStickyLayout: bool,
    shouldRenderSellerLanguage: bool,
    repeatScore: shape({
        score: bool
    }),
    notableClients: arrayOf(object)
};

GigOverview.defaultProps = {
    studioInfo: {},
    notableClients: []
};

GigOverview.contextTypes = {
    biEvents: object
};

const mapStateToProps = ({ ugc }) => {
    const { gigTitle } = getCurrentContent({ ugc });

    return {
        gigTitle
    };
};

const ConnectedOverView = connect(mapStateToProps)(GigOverview);

export { GigOverview, ConnectedOverView };
export default SafePureComponent(ConnectedOverView);
